import React, { useState } from 'react';
import { Gift, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useToast } from '../hooks/use-toast';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';

export const AddToRegistryButton = ({ productId }) => {
  const { toast } = useToast();
  const { isAuthenticated } = useAuth();
  const [busy, setBusy] = useState(false);

  const add = async () => {
    setBusy(true);
    try {
      await api.post('/registry/items', { productId, quantity: 1 });
      toast({ title: 'Adăugat în lista de naștere', description: 'Îl găsești în Lista mea de naștere.' });
    } catch (e) {
      const noList = e.response?.status === 404 && /listă/i.test(e.response?.data?.detail || '');
      toast({
        title: noList ? 'Creează întâi lista' : 'Eroare',
        description: noList ? 'Intră pe pagina Lista de naștere și completează datele.' : (e.response?.data?.detail || 'Nu s-a putut adăuga'),
        variant: noList ? undefined : 'destructive',
      });
    } finally { setBusy(false); }
  };

  if (!isAuthenticated?.()) {
    return (
      <Link to="/lista-nasterii" className="inline-flex items-center gap-2 text-sm font-medium text-green-600 hover:underline" data-testid="pdp-registry-login">
        <Gift className="h-4 w-4" /> Adaugă în lista de naștere
      </Link>
    );
  }
  return (
    <button onClick={add} disabled={busy} className="inline-flex items-center gap-2 text-sm font-medium text-green-600 hover:underline disabled:opacity-60" data-testid="pdp-add-to-registry">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Gift className="h-4 w-4" />} Adaugă în lista de naștere
    </button>
  );
};
